<script setup>
import { onMounted, watch } from 'vue'
import { storeToRefs } from 'pinia'

import ShipTableRow from '@/components/ship/ShipTableRow.vue'
import BulkDeleteDialog from '@/components/dialog/BulkDeleteDialog.vue'

import { useShipStore } from '@/stores/ship'
import { useFairleadStore } from '@/stores/fairlead'
import ShipTableHeader from '@/components/ship/ShipTableHeader.vue'

const fairleadStore = useFairleadStore()
const shipStore = useShipStore()

const { items, itemsAvailable, optionsAvailable } = storeToRefs(shipStore)

const { selectedItems, writeLoading, deleteDialog } = storeToRefs(fairleadStore)

watch(
  () => items.value.length,
  () => {
    shipStore.sortItems()
  }
)

const removeItems = async () => {
  selectedItems.value.forEach((item) => {
    fairleadStore.setParameter(item, 'mooring_point', null)
    fairleadStore.setParameter(item, 'winch', null)
    fairleadStore.setParameter(item, 'line_type', null)
    fairleadStore.setParameter(item, 'color', null)
    fairleadStore.setParameter(item, 'horizontal_angle', NaN)
    fairleadStore.setParameter(item, 'horizontal_color', null)
    fairleadStore.setParameter(item, 'vertical_angle', NaN)
    fairleadStore.setParameter(item, 'vertical_color', null)
  })
  await fairleadStore.bulkUpdate(selectedItems.value)
  fairleadStore.removeEditedItems(selectedItems.value)
  fairleadStore.emptySelectedItems()
  fairleadStore.toggleDeleteDialog()
}

onMounted(() => {
  shipStore.sortItems()
})
</script>

<template>
  <v-table
    v-if="itemsAvailable && optionsAvailable"
    ref="table"
    class="ma-0 d-flex flex-column overflow-y-auto"
    fixed-header
  >
    <thead>
      <ShipTableHeader />
    </thead>
    <tbody>
      <ShipTableRow v-for="item in items" :item="item" :key="item.id" />
    </tbody>
  </v-table>

  <BulkDeleteDialog
    :bulk-delete="true"
    :items-to-delete="selectedItems"
    :delete-dialog="deleteDialog"
    :delete-loading="writeLoading"
    @delete="removeItems"
    @toggle-dialog="fairleadStore.toggleDeleteDialog()"
  >
    <template #info>
      <v-alert type="warning" variant="tonal" class="ma-1" density="compact">
        This action will remove the connection between the selected fairleads and the mooring point.
        These fairleads will be available for reconnection.
      </v-alert>
    </template>
  </BulkDeleteDialog>
</template>

<style scoped></style>
